/* eslint-disable tailwindcss/no-arbitrary-value */

type Props = {
  onClick: () => void;
};

export const PlayButton = ({ onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    className="absolute left-1/2 top-1/2 z-[2] flex size-shapes/pictogram-md -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full p-spacing/padding/soft-12px shadow-[0_0_12px_rgba(0,0,0,0.15)] transition bg-fill/primary text-white hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fill/primary"
    aria-label="Play video"
  >
    <svg
      className="ml-2"
      width="28"
      height="35"
      viewBox="0 0 28 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 34.615V0L27.1792 17.3075L0 34.615ZM2.56417 29.8908L22.4808 17.3075L2.56417 4.72417V29.8908Z"
        fill="currentColor"
      />
    </svg>
  </button>
);
